__turbopack_context__.v({
  "card": "_4_mBGq_card",
  "img": "_4_mBGq_img",
  "imgContainer": "_4_mBGq_imgContainer",
  "publishedAt": "_4_mBGq_publishedAt",
  "title": "_4_mBGq_title",
});
